import { render, staticRenderFns } from "./OnTimePaymentReport.vue?vue&type=template&id=db37ebca"
import script from "./OnTimePaymentReport.vue?vue&type=script&lang=js"
export * from "./OnTimePaymentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db37ebca')) {
      api.createRecord('db37ebca', component.options)
    } else {
      api.reload('db37ebca', component.options)
    }
    module.hot.accept("./OnTimePaymentReport.vue?vue&type=template&id=db37ebca", function () {
      api.rerender('db37ebca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/OnTimePaymentReport.vue"
export default component.exports